export interface UserAttributeInterface {
    count: number;
    data: InvestmentPreferences[];
    status: number;
    total: number;
    errors?: Error[];
}

export enum AttributeCode {
    AUTO_INVESTMENT_FROM_WALLET_TYPE = 'AUTO_INVESTMENT_FROM_WALLET_TYPE',
    NCASH_WD_LIMIT = 'NCASH_WD_LIMIT',
    NCASH_WD_FREQUENCY = 'NCASH_WD_FREQUENCY',
    NCASH_WD_DATE_OF_MONTH = 'NCASH_WD_DATE_OF_MONTH',
    NCASH_WD_AMOUNT = 'NCASH_WD_AMOUNT',
    INVESTMENT_FUND_ALLOCATION = 'INVESTMENT_FUND_ALLOCATION',
    EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION',
    FF_REINVEST_PRO_FUND_ALLOCATION = 'FF_REINVEST_PRO_FUND_ALLOCATION',
    FF_REINVEST_PRO = 'FF_REINVEST_PRO',
    PREFERRED_LOAN_TENURE = 'PREFERRED_LOAN_TENURE',
    PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE = 'PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE',
    PRO_PREFERRED_LOAN_TENURE = 'PRO_PREFERRED_LOAN_TENURE',
    PRO_PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE = 'PRO_PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE',
    FLEX_PREFERRED_RATING_LOW_RISK = 'FLEX_PREFERRED_RATING_LOW_RISK',
    FLEX_PREFERRED_RATING_MEDIUM_RISK = 'FLEX_PREFERRED_RATING_MEDIUM_RISK',
    FLEX_PREFERRED_RATING_HIGH_RISK = 'FLEX_PREFERRED_RATING_HIGH_RISK'
}

export enum RISK_RANGE {
    A1_A6 = 'A1-A6',
    B1_B6 = 'B1-B6',
    C1_C6 = 'C1-C6',
}

export enum RISK_RANGE_SCORE {
    A1_A6 = 1,
    B1_B6 = 3,
    C1_C6 = 5
};

export enum AttributeValue {
    SWIFT = 'SWIFT',
    MAX_LIMIT = 'MAX_LIMIT',
    CUSTOM = 'CUSTOM',
    INTEREST_ONLY = 'INTEREST_ONLY',
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY',
    SEMI_ANNUALLY = 'SEMI-ANNUALLY',
    ANNUALLY = 'ANNUALLY'

}

export const nCashFrequencies = [
    { key: 'Monthly', value: 'MONTHLY' },
    { key: 'Quarterly', value: 'QUARTERLY' },
    { key: 'Semi-Annually', value: 'SEMI-ANNUALLY' },
    { key: 'Annually', value: 'ANNUALLY' }
];

export const nCashDates = [
    { key: '10', value: '10' },
    { key: '20', value: '20' },
    { key: '30', value: '30' }
];

export enum SUB_PRODUCTS {
    F6 = "F6",
    F12 = "F12",
    F24 = "F24",
    F36 = "F36",
    F18 = "F18"
}

export enum MATURITY_PRODUCTS_NAME {
    F18 = "F18/20"
}

export interface InvestmentPreferences {
    automaticInvestmentsFromWallet?: boolean;
    investmentPreferences: InvestmentPreference[];
    userId?: string;
    isNCashModified?: boolean;
    isSwiftModified?: boolean;
    preferredLoanTenure?: boolean;
    preferredMaxLoanAllocationAmountPercentage?: boolean;
}

export interface InvestmentPreference {
    attributeCode: string | AttributeCode,
    attributeValue: any,
    productCode?: string,
    productVersion?: number
}


export class UserAttribute {
    private static nCash = ['NCASH_WD_LIMIT', 'NCASH_WD_FREQUENCY', 'NCASH_WD_DATE_OF_MONTH', 'NCASH_WD_AMOUNT']

    public static createDefaultNCash(): InvestmentPreference[] {
        const userAttributeNCash = [];
        this.nCash.forEach(attributeCode => userAttributeNCash.push({ attributeCode: attributeCode, attributeValue: null }))
        return userAttributeNCash;
    }
}

export interface Error {
    errorMessage: string;
}